import { EffectCallback, Inputs, useEffect, useLayoutEffect } from "preact/hooks";
import UseEffectOptions from "./UseEffectOptions";

export default function useEffectWithOptions(effect: EffectCallback, inputs?: Inputs, options?: UseEffectOptions) {
    (options?.onLayout ? useLayoutEffect : useEffect)(effect, inputs);
}
